import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import Modal from '../Modal'
import { pxToRem, color } from '../../utils'
import { Button } from '../Form'
import { date } from '../../utils/format'

const ModalLayout = styled.div`
  display: flex;
  padding-left: ${pxToRem(20)};
  padding-right: ${pxToRem(20)};

  > div:first-child {
    padding-top: ${pxToRem(20)};
    padding-bottom: ${pxToRem(20)};
    width: 180px;
  }

  > div:last-child {
    flex: 1;
    padding: ${pxToRem(30)};
    padding-top: ${pxToRem(20)};
    padding-bottom: ${pxToRem(20)};
    border-left: 1px solid #d3dce2;
    margin-left: ${pxToRem(16)};
  }

  > div > p > h3 {
    text-transform: uppercase;
    font-size: ${pxToRem(14)};
  }

  > div > p {
    font-size: ${pxToRem(14)};
  }

  @media only screen and (max-width: 700px) {
    flex-direction: column;
    > div:last-child {
      border: none;
      padding-left: 0;
      margin-left: 0;
    }
  }
`

const DefinitionList = styled.dl`
  margin: 2em 0;
  &:first-child {
    margin-top: 0;
  }
  dd,
  dt {
    padding: 0;
    margin: 0;
    font-size: ${pxToRem(14)};
  }
  dd {
    span,
    strong {
      color: ${color.secondary};
    }
    strong {
      font-weight: bold;
    }
  }
  dt {
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 1em;
  }
  & > dl {
    overflow: auto;
    margin-top: 0;
    max-height: 260px;
  }
  dl {
    &:first-child {
      margin-top: 0;
    }
    dt {
      color: ${color.primary};
      margin-bottom: 0;
      font-weight: bold;
    }
  }
`

const ProductPhoto = styled.img`
  width: ${pxToRem(180)};
  display: block;
  margin-bottom: ${pxToRem(17)};
`

const AttributeLabel = styled.h3`
  font-size: ${pxToRem(15)};
  color: ${color.secondary};
`

const Attribute = styled.div`
  font-size: ${pxToRem(13)};
  margin-bottom: ${pxToRem(10)};
`

class ProductMapModal extends Component {

  render() {
    const {
      closeModal,
      productMap,
      open = false,
      fetching,
      fetch_errors
    } = this.props

    const {
      name,
      photo_path,
      document_path,
      popular_name,
      maximum_storage,
      kinds,
      fispq_issue_date,
      fispq_update_date,
      ppe,
      ppe_observation,
      storage,
      tolerance_limit,
      first_aid,
      ambiental_danger,
      product_spill,
      incompatibility
    } = productMap

    return (

      <Modal
        title={name}
        safeContent={false}
        loading={fetching.productMap}
        open={open}
        size={'large'}
        error={fetch_errors.productMap}
        closeMethod={closeModal}
      >
        <ModalLayout>
          <div>
            {photo_path && <ProductPhoto src={photo_path} />}
            {document_path && (
              <Button link href={document_path} target="_blank">
                Gerar Fispq's
              </Button>
            )}
            <DefinitionList>
              <dt>I.D / NOME POPULAR</dt>
              <dd>
                <span>{popular_name || '---'}</span>
              </dd>
            </DefinitionList>
            <DefinitionList>
              <dt>Qtd. Máxima de Armazenamento</dt>
              <dd>
                <span>{maximum_storage || '---'}</span>
              </dd>
            </DefinitionList>
            <DefinitionList>
              <dt>Id. de Perigo</dt>
              <dd>
                <span>{kinds || '---'}</span>
              </dd>
            </DefinitionList>
            <DefinitionList>
              <dt>Data emissão FISPQ</dt>
              <dd>
                <span>{fispq_issue_date ? date(fispq_issue_date) : '---'}</span>
              </dd>
            </DefinitionList>
            <DefinitionList>
              <dt>Data atualização FISPQ</dt>
              <dd>
                <span>{fispq_update_date ? date(fispq_update_date) : '---'}</span>
              </dd>
            </DefinitionList>
          </div>
          <div>
            {ppe && (
              <div>
                <AttributeLabel>EPI/EPC</AttributeLabel>
                <Attribute dangerouslySetInnerHTML={{ __html: ppe }} />
                <Attribute dangerouslySetInnerHTML={{ __html: ppe_observation }} />
              </div>
            )}
            {storage && (
              <div>
                <AttributeLabel>Armazenamento</AttributeLabel>
                <Attribute dangerouslySetInnerHTML={{ __html: storage }} />
              </div>
            )}
            {tolerance_limit && (
              <div>
                <AttributeLabel>Limite de tolerância</AttributeLabel>
                <Attribute dangerouslySetInnerHTML={{ __html: tolerance_limit }} />
              </div>
            )}
            {first_aid && (
              <div>
                <AttributeLabel>Primeiros Socorros</AttributeLabel>
                <Attribute dangerouslySetInnerHTML={{ __html: first_aid }} />
              </div>
            )}
            {ambiental_danger && (
              <div>
                <AttributeLabel>Risco Ambiental</AttributeLabel>
                <Attribute dangerouslySetInnerHTML={{ __html: ambiental_danger }} />
              </div>
            )}
            {product_spill && (
              <div>
                <AttributeLabel>Derramamento</AttributeLabel>
                <Attribute dangerouslySetInnerHTML={{ __html: product_spill }} />
              </div>
            )}
            {incompatibility && (
              <div>
                <AttributeLabel>Incompatibilidade</AttributeLabel>
                <Attribute dangerouslySetInnerHTML={{ __html: incompatibility }} />
              </div>
            )}
          </div>
        </ModalLayout>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  productMap: state.productMap.productMap,
  fetching: state.productMap.fetching,
  fetch_errors: state.productMap.fetch_errors
})

export default connect(mapStateToProps)(ProductMapModal)



// WEBPACK FOOTER //
// ./src/components/ProductModal/ProductMapModal.js